<template>
  <div>
    <mdb-modal removeBackdrop centered @close="$store.commit('clearCurrentModal')" elegant>
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue"
          >Great to have you here!</mdb-modal-title
        >
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="mb-4 mt-n3">
          Log in to get more detailed information or send requests to the test
          studios.
        </p>
        <form v-on:submit.prevent v-on:keyup.enter="loginUser">
          <div>
            <mdb-input
              id="email"
              ref="email"
              label="Your email"
              v-model="email"
              outline
            />
            <mdb-input
              label="Your password"
              type="password"
              v-model="password"
              outline
            />
          </div>
          <validation-info :text="validationInfo" />
          <div class="text-center">
            <mdb-btn class="btn btn-isi" @click="loginUser">Login</mdb-btn>
          </div>
        </form>
      </mdb-modal-body>
      <mdb-modal-footer class="mx-5 d-flex justify-content-center" end>
        <a
          class="link"
          @click="
            $store.commit('setCurrentModal', { type: 'forgotPasswordModal' })
          "
          >Forgot password?</a
        >
        <span class="mx-2">&#124;</span>
        <a
          class="link"
          @click="$store.commit('setCurrentModal', { type: 'registerModal' })"
          >Create an account</a
        >
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import ValidationInfo from "../ValidationInfo.vue";

export default {
  components: {
    ValidationInfo,
  },
  created() {
    window.gtag("event", "open_login_dialog", {
      event_category: "login",
    });
  },
  mounted() {
    this.$refs.email.focus();
  },
  data() {
    return {
      email: "",
      password: "",
      validationInfo: "",
    };
  },
  methods: {
    loginUser() {
      if (!this.email) {
        this.validationInfo = "Please type in your email address.";
        return;
      }
      // simple check for frontend
      if (!/\S+@\S+\.\S+/.test(this.email)) {
        this.validationInfo = "Please provide a valid email address.";
        return;
      }
      if (!this.password) {
        this.validationInfo = "Please type in your password.";
        return;
      }
      this.validationInfo = "";

      this.$store
        .dispatch("loginUser", {
          email: this.email,
          password: this.password,
          $http: this.$http,
        })
        .then(() => {
          this.$store.commit("clearCurrentModal");
          window.gtag("event", "login", {
            event_category: "login",
            method: "manual",
          });
          // search bar neu rendern, da nun unter Umständen andere Studios angezeigt werden
          this.$store.commit("increaseSearchBarRenderKey");
        })
        .catch((err) => {
          this.validationInfo = err;
        });
    },
  },
};
</script>
